import React from "react";

export const SvgForEditLogo = (
   <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
      <g id="Group_17126" data-name="Group 17126" transform="translate(-1805 -135)">
         <rect
            id="Rectangle_6668"
            data-name="Rectangle 6668"
            width="40"
            height="40"
            rx="20"
            transform="translate(1805 135)"
            fill="#2d3450"
         />
         <g id="Group_17125" data-name="Group 17125" transform="translate(247 -247)">
            <path
               id="Path_11169"
               data-name="Path 11169"
               d="M10.388,6H4.642A1.642,1.642,0,0,0,3,7.642V19.135a1.642,1.642,0,0,0,1.642,1.642H16.135a1.642,1.642,0,0,0,1.642-1.642V13.388"
               transform="translate(1567 389.223)"
               fill="none"
               stroke="#fff"
            />
            <path
               id="Path_11170"
               data-name="Path 11170"
               d="M19.909,3.286a1.6,1.6,0,0,1,2.26,2.26L15.013,12.7,12,13.455l.753-3.013Z"
               transform="translate(1563.363 391.182)"
               fill="none"
               stroke="#fff"
            />
         </g>
      </g>
   </svg>
);

export const SendForReviewSvg = (
   <svg xmlns="http://www.w3.org/2000/svg" width="113" height="113" viewBox="0 0 113 113">
      <g id="Group_16724" data-name="Group 16724" transform="translate(-1083.817 -382.238)">
         <circle
            id="Ellipse_604"
            data-name="Ellipse 604"
            cx="56.5"
            cy="56.5"
            r="56.5"
            transform="translate(1083.817 382.238)"
            fill="#36dae9"
            opacity="0.1"
         />
         <circle
            id="Ellipse_603"
            data-name="Ellipse 603"
            cx="50.5"
            cy="50.5"
            r="50.5"
            transform="translate(1089.817 388.238)"
            fill="#36dae9"
            opacity="0.18"
         />
         <circle
            id="Ellipse_602"
            data-name="Ellipse 602"
            cx="44.5"
            cy="44.5"
            r="44.5"
            transform="translate(1095.817 394.238)"
            fill="#36dae9"
         />
         <g id="Group_15537" data-name="Group 15537" transform="translate(1117.152 415.063)">
            <path
               id="Path_10944"
               data-name="Path 10944"
               d="M46.839,11.981a14.588,14.588,0,0,1-.983,2.37A5.456,5.456,0,0,1,41.168,17c-1.919.05-3.84.019-5.761.011a1.825,1.825,0,1,1,.028-3.65c1.478-.007,2.957,0,4.435,0h.6c-.581-.816-1.06-1.568-1.616-2.257A19.175,19.175,0,0,0,28.822,4.441,19.1,19.1,0,0,0,11.943,7.4,18.991,18.991,0,0,0,4.106,19.42a19.052,19.052,0,0,0,3.32,15.5A19.3,19.3,0,0,0,19.46,42.75a17.77,17.77,0,0,0,4.948.374,5,5,0,0,1,1.36.04,1.774,1.774,0,0,1,1.4,1.965,1.826,1.826,0,0,1-1.712,1.613A23,23,0,0,1,6.988,40.079a22.472,22.472,0,0,1-6.617-12.6A22.741,22.741,0,0,1,3.232,11.569a22.96,22.96,0,0,1,15.044-11C19.338.324,20.438.244,21.521.084c.118-.018.233-.056.35-.084h3.11a3.528,3.528,0,0,0,.442.091,22.565,22.565,0,0,1,6.968,1.7,23.349,23.349,0,0,1,10.51,8.62c.068.1.15.19.283.357,0-1.755-.008-3.4,0-5.045a1.812,1.812,0,0,1,1.449-1.761,1.844,1.844,0,0,1,2.018.994c.059.117.124.232.186.348Z"
               transform="translate(0 0)"
               fill="#fff"
            />
            <path
               id="Path_10945"
               data-name="Path 10945"
               d="M136.2,69.729c0,2.392-.007,4.783.005,7.174a2.026,2.026,0,0,1-.616,1.516q-3.538,3.538-7.08,7.073a1.84,1.84,0,1,1-2.57-2.624q2.106-2.095,4.2-4.2c.7-.7,1.391-1.41,2.106-2.094a.944.944,0,0,0,.3-.759q-.014-6.695-.005-13.39a1.828,1.828,0,0,1,2.87-1.525,1.779,1.779,0,0,1,.786,1.561q-.006,3.633,0,7.266"
               transform="translate(-110.947 -53.622)"
               fill="#fff"
            />
            <path
               id="Path_10946"
               data-name="Path 10946"
               d="M371.771,228.588a1.823,1.823,0,0,1,1.809,2.134,19.716,19.716,0,0,1-.514,2.027,1.821,1.821,0,0,1-2.246,1.2,1.768,1.768,0,0,1-1.283-2.071,17.98,17.98,0,0,1,.553-2.108,1.784,1.784,0,0,1,1.68-1.186"
               transform="translate(-327.178 -202.404)"
               fill="#fff"
            />
            <path
               id="Path_10947"
               data-name="Path 10947"
               d="M268.576,357.573a1.877,1.877,0,0,1-1.749-1.378,1.766,1.766,0,0,1,.79-2.01,19.17,19.17,0,0,1,1.908-.962,1.809,1.809,0,0,1,2.331.84,1.79,1.79,0,0,1-.673,2.384c-.613.362-1.26.667-1.905.969a3.26,3.26,0,0,1-.7.158"
               transform="translate(-236.201 -312.628)"
               fill="#fff"
            />
            <path
               id="Path_10948"
               data-name="Path 10948"
               d="M330.583,303.905a1.349,1.349,0,0,1,.028-.382,5.4,5.4,0,0,1,2.354-2.788,1.713,1.713,0,0,1,1.986.514,1.745,1.745,0,0,1,.192,2.081,16,16,0,0,1-1.517,1.879,1.713,1.713,0,0,1-1.988.31,1.747,1.747,0,0,1-1.055-1.613"
               transform="translate(-292.715 -266.159)"
               fill="#fff"
            />
         </g>
      </g>
   </svg>
);

export const SaveButtonSvg = (
   <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15.966" viewBox="0 0 16 15.966">
      <g id="Group_17156" data-name="Group 17156" transform="translate(-1853 -452)">
         <path
            id="Path_11222"
            data-name="Path 11222"
            d="M.138.954.2.829C.3.914.331.808.379.762A4,4,0,0,1,.749.4.221.221,0,0,0,.865.172l.1-.043c.035.034.091.1.1.1.1-.057.2-.129.3-.2l.1-.022.11.125L1.7.005C1.735,0,1.774,0,1.812,0H12.025c.039,0,.077,0,.116.005a1.513,1.513,0,0,0,.149.128,1.484,1.484,0,0,1,.236.139Q14.1,1.839,15.667,3.416a1.747,1.747,0,0,1,.167.294.662.662,0,0,0,.125.115c0,.039.005.077.005.116q0,5.106,0,10.213c0,.039,0,.077-.005.116l-.127.107.124.126-.031.1a.3.3,0,0,0-.124.433l-.032.066a.6.6,0,0,0-.164.079c-.135.127-.265.259-.387.4a.616.616,0,0,0-.075.181l-.11.043c-.139-.124-.287-.069-.334.124l-.2.032-.11-.125-.123.127c-.044,0-.088.005-.132.005H1.829c-.044,0-.088,0-.132-.005l-.107-.127-.126.124h-.1a.324.324,0,0,0-.4-.2c-.019.012-.024.046-.036.069L.9,15.8c.006-.179-.157-.236-.255-.329-.151-.144-.25-.355-.479-.407L.141,15.04c.03-.05.1-.11.084-.148-.035-.119-.06-.258-.217-.29v-.1l.125-.11-.127-.123C0,14.225,0,14.181,0,14.137Q0,7.983,0,1.828C0,1.784,0,1.74.006,1.7l.127-.107L.008,1.463v-.1a.373.373,0,0,0,.22-.318C.221,1.01.169.984.138.954m4.053,9.717c-.031-.115-.1-.159-.2-.09a1.494,1.494,0,0,0-.274.205c-.1.106-.089.231.007.29v3.817h8.5V11.076c.115,0,.155-.057.094-.157a1.359,1.359,0,0,0-.211-.288c-.133-.124-.251-.1-.323.04-.113-.009-.225-.026-.338-.027q-3.47,0-6.94,0c-.1,0-.2.017-.305.027M1.5,14.907H2.661c0-.081,0-.141,0-.2q0-1.715.006-3.43l.127-.107-.125-.126v-.1a.373.373,0,0,0,.22-.318c-.007-.035-.058-.061-.089-.091l.06-.125c.1.085.133-.021.18-.067a4.012,4.012,0,0,1,.37-.363.221.221,0,0,0,.116-.227l.1-.043c.03.034.073.1.088.1.115-.045.278-.023.311-.2l.1-.022.109.125.123-.127c.061,0,.121-.005.182-.005h6.887c.061,0,.121,0,.182.005l.107.127.126-.124.236.057c-.061.125.058.128.117.154s.145.035.146-.079l.17.092c.014.052.013.117.045.153a5.042,5.042,0,0,0,.364.368,1.031,1.031,0,0,0,.191.112l.056.1c-.03.035-.094.084-.086.1.048.106.03.259.187.3l.031.1-.125.11.127.123V14.9h1.168c0,.138.1.131.166.077a2.33,2.33,0,0,0,.332-.326c.077-.091.044-.173-.07-.216a.268.268,0,0,0,0-.033q0-5.172,0-10.344a.221.221,0,0,0-.06-.14q-1.39-1.4-2.785-2.787a.205.205,0,0,0-.123-.062c-.248-.006-.5,0-.754,0v.178c0,.926,0,1.852,0,2.777a2.6,2.6,0,0,1-.035.474,1.023,1.023,0,0,1-.954.824c-1.491.012-2.982.005-4.473,0A1.087,1.087,0,0,1,4.792,4.4q0-1.572,0-3.143V1.089c-.018-.016-.022-.022-.026-.022-1.025,0-2.051-.01-3.076,0a.578.578,0,0,0-.627.663q.011,6.236,0,12.473c0,.088,0,.177,0,.265-.13,0-.119.1-.074.156a2.505,2.505,0,0,0,.354.355c.055.045.154.058.157-.073M10.108,1.074H5.864V4.247h4.244Z"
            transform="translate(1853 452)"
            fill="#030404"
         />
         <path
            id="Path_11225"
            data-name="Path 11225"
            d="M3.655,339.116c.251.057.36.288.525.446.107.1.286.165.28.36a1.49,1.49,0,0,1-.8-.806"
            transform="translate(1849.523 127.866)"
            fill="#030404"
         />
         <path
            id="Path_11226"
            data-name="Path 11226"
            d="M5.2,3.88a.242.242,0,0,1-.127.248,4.389,4.389,0,0,0-.406.4c-.052.05-.089.166-.2.073A1.487,1.487,0,0,1,5.2,3.88"
            transform="translate(1848.749 448.309)"
            fill="#030404"
         />
         <path
            id="Path_11227"
            data-name="Path 11227"
            d="M340.925,340.6a.675.675,0,0,1,.082-.2c.133-.152.276-.3.423-.436a.662.662,0,0,1,.179-.087l-.225.36-.46.361"
            transform="translate(1527.142 127.138)"
            fill="#030404"
         />
         <path
            id="Path_11228"
            data-name="Path 11228"
            d="M350.375,335.948l.225-.36.035-.072.1-.148c.156.107.145.265-.022.407-.049.042-.078.116-.132.143a.667.667,0,0,1-.209.03"
            transform="translate(1518.152 131.431)"
            fill="#fff"
         />
         <path
            id="Path_11229"
            data-name="Path 11229"
            d="M20.964,354.265c.013-.026.018-.063.039-.076a.355.355,0,0,1,.435.22l-.474-.144"
            transform="translate(1833.057 113.548)"
            fill="#030404"
         />
         <path
            id="Path_11230"
            data-name="Path 11230"
            d="M.175,328.65c.172.035.2.188.238.318.012.041-.059.107-.092.162l-.145-.48"
            transform="translate(1852.834 137.822)"
            fill="#030404"
         />
         <path
            id="Path_11231"
            data-name="Path 11231"
            d="M.318,21.492c.034.033.09.061.1.1a.409.409,0,0,1-.241.349l.143-.448"
            transform="translate(1852.834 431.554)"
            fill="#030404"
         />
         <path
            id="Path_11232"
            data-name="Path 11232"
            d="M354.741,328.978l-.1.148a.33.33,0,0,1,.136-.475l-.033.327"
            transform="translate(1514.148 137.821)"
            fill="#030404"
         />
         <path
            id="Path_11233"
            data-name="Path 11233"
            d="M22.126.662c-.107.074-.211.152-.324.215-.014.008-.074-.068-.113-.105l.437-.11"
            transform="translate(1832.367 451.37)"
            fill="#030404"
         />
         <path
            id="Path_11234"
            data-name="Path 11234"
            d="M330.941,354.381c.051-.211.214-.272.366-.136l-.366.136"
            transform="translate(1536.64 113.542)"
            fill="#030404"
         />
         <path
            id="Path_11235"
            data-name="Path 11235"
            d="M.124,321.164l.139.135-.136.12q0-.128,0-.255"
            transform="translate(1852.882 144.944)"
            fill="#030404"
         />
         <path
            id="Path_11236"
            data-name="Path 11236"
            d="M356.549,321.419l-.136-.138.139-.118q0,.128,0,.255"
            transform="translate(1512.407 144.944)"
            fill="#030404"
         />
         <path
            id="Path_11237"
            data-name="Path 11237"
            d="M.126,32.938l.136.138-.139.118q0-.128,0-.255"
            transform="translate(1852.883 420.665)"
            fill="#030404"
         />
         <path
            id="Path_11238"
            data-name="Path 11238"
            d="M33.2.124l-.135.139-.12-.136.255,0"
            transform="translate(1821.66 451.882)"
            fill="#030404"
         />
         <path
            id="Path_11239"
            data-name="Path 11239"
            d="M32.943,356.5l.138-.136.118.139-.255,0"
            transform="translate(1821.66 111.454)"
            fill="#030404"
         />
         <path
            id="Path_11240"
            data-name="Path 11240"
            d="M321.207,356.5l.135-.139.12.136-.255,0"
            transform="translate(1545.9 111.457)"
            fill="#030404"
         />
         <path
            id="Path_11242"
            data-name="Path 11242"
            d="M64.37,220.209a1.077,1.077,0,0,1,.4-.509l.077-.1.255-.11a.242.242,0,0,1-.127.248,4.381,4.381,0,0,0-.406.4c-.052.05-.089.166-.2.073"
            transform="translate(1791.478 242.22)"
            fill="#030404"
         />
         <path
            id="Path_11243"
            data-name="Path 11243"
            d="M325.67,325.366a.674.674,0,0,0,.469-.508c.126.046.162.136.077.236a2.548,2.548,0,0,1-.363.357c-.075.059-.178.066-.182-.084"
            transform="translate(1541.654 141.43)"
            fill="#030404"
         />
         <path
            id="Path_11244"
            data-name="Path 11244"
            d="M265.5,237.946a.573.573,0,0,0-.444-.334c.079-.154.209-.179.354-.044a1.486,1.486,0,0,1,.231.315c.067.109.023.169-.1.172l-.009-.071-.029-.037"
            transform="translate(1599.684 225.037)"
            fill="#030404"
         />
         <path
            id="Path_11245"
            data-name="Path 11245"
            d="M281.59,220.821a1.483,1.483,0,0,1,.658.694,1.129,1.129,0,0,1-.21-.123,5.522,5.522,0,0,1-.4-.4c-.035-.039-.034-.111-.05-.168"
            transform="translate(1583.875 240.952)"
            fill="#030404"
         />
         <path
            id="Path_11246"
            data-name="Path 11246"
            d="M82.576,237.549c-.285.017-.4.225-.516.443-.106-.065-.119-.2-.008-.317a1.634,1.634,0,0,1,.3-.225c.117-.076.191-.027.224.1"
            transform="translate(1774.656 225.1)"
            fill="#030404"
         />
         <path
            id="Path_11247"
            data-name="Path 11247"
            d="M21.6,325.657a.687.687,0,0,0,.479.48c0,.143-.111.129-.172.08a2.744,2.744,0,0,1-.388-.388c-.05-.061-.061-.168.081-.171"
            transform="translate(1832.558 140.67)"
            fill="#030404"
         />
         <path
            id="Path_11248"
            data-name="Path 11248"
            d="M60.074,237.532l.143-.449c.034.033.09.061.1.1a.408.408,0,0,1-.241.349"
            transform="translate(1795.85 225.424)"
            fill="#030404"
         />
         <path
            id="Path_11249"
            data-name="Path 11249"
            d="M81.589,216.379l.437-.11c-.036.191-.214.167-.341.216-.016.006-.063-.069-.1-.106"
            transform="translate(1775.028 245.329)"
            fill="#030404"
         />
         <path
            id="Path_11250"
            data-name="Path 11250"
            d="M294.5,237.356l.11.435c-.171-.041-.152-.208-.2-.324-.009-.019.061-.073.094-.111"
            transform="translate(1571.397 225.164)"
            fill="#030404"
         />
         <path
            id="Path_11251"
            data-name="Path 11251"
            d="M271.5,217.075l.287.081c0,.125-.09.117-.16.087s-.195-.031-.128-.168"
            transform="translate(1593.561 244.56)"
            fill="#030404"
         />
         <path
            id="Path_11252"
            data-name="Path 11252"
            d="M261.308,215.731l.255,0-.138.136-.118-.139"
            transform="translate(1603.286 245.847)"
            fill="#030404"
         />
         <path
            id="Path_11253"
            data-name="Path 11253"
            d="M92.842,215.734l.255,0-.135.139-.12-.136"
            transform="translate(1764.277 245.846)"
            fill="#030404"
         />
         <path
            id="Path_11254"
            data-name="Path 11254"
            d="M60.023,248.8q0-.128,0-.255l.136.138-.139.118"
            transform="translate(1795.898 214.482)"
            fill="#030404"
         />
         <path
            id="Path_11255"
            data-name="Path 11255"
            d="M296.649,248.546q0,.128,0,.255l-.139-.135Z"
            transform="translate(1569.392 214.482)"
            fill="#030404"
         />
         <path
            id="Path_11256"
            data-name="Path 11256"
            d="M72.623,221.744l-.077.1.077-.1"
            transform="translate(1783.676 240.103)"
            fill="#090a0a"
         />
         <path
            id="Path_11257"
            data-name="Path 11257"
            d="M274.179,247.058l.029.037-.029-.037"
            transform="translate(1591.001 215.917)"
            fill="#080908"
         />
         <rect
            id="Rectangle_6756"
            data-name="Rectangle 6756"
            width="16"
            height="15.966"
            transform="translate(1853 452)"
            fill="none"
         />
      </g>
   </svg>
);

export const EditButtonSvg = (
   <svg xmlns="http://www.w3.org/2000/svg" width="17.553" height="17.553" viewBox="0 0 17.553 17.553">
      <g id="Group_17160" data-name="Group 17160" transform="translate(-1569.3 -393.146)">
         <path
            id="Path_11169"
            data-name="Path 11169"
            d="M10.084,6H4.574A1.574,1.574,0,0,0,3,7.574v11.02a1.574,1.574,0,0,0,1.574,1.574h11.02a1.574,1.574,0,0,0,1.574-1.574v-5.51"
            transform="translate(1567 389.831)"
            fill="none"
            stroke="#1e2838"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.4"
         />
         <path
            id="Path_11170"
            data-name="Path 11170"
            d="M21.063,3.354a1.831,1.831,0,0,1,2.59,2.589l-8.2,8.2L12,15.007l.863-3.453Z"
            transform="translate(1561.811 391.182)"
            fill="none"
            stroke="#1e2838"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.4"
         />
      </g>
   </svg>
);
